import { Box } from "@mui/material"
import { CopDocumentList } from "./cop-document-list"
import { CopImportProgressLog } from "./cop-import-progress-log"

export function CopGroupDocumentsTab({ codeOfPracticeId }) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
            <CopDocumentList codeOfPracticeId={codeOfPracticeId} />
            <CopImportProgressLog />
        </Box>
    )
}
